import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { autocompleteProductsStyles } from "@insite/content-library/Widgets/Header/AutocompleteProducts";

import { css } from "styled-components";

autocompleteProductsStyles.image = mergeToNew(autocompleteProductsStyles.image, {
    width: "50px",
    css: css`
        img {
            max-height: 100%;
            height: auto;
            max-width: 100%;
        }
    `,
});
